module.exports = __webpack_public_path__ + "static/media/16_harrys.a10b1da8.svg";